import { useState } from "react";

import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { Avatar, Box, CircularProgress, IconButton } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

import { OffWhite } from "assets/colors";
import UploadCell from "components/Table/Cell/UploadCell";
import useValidImages from "hooks/useValidImages";

import styles from "./styles";
const useStyles = makeStyles(styles as any);

interface IFilePreviewProps {
  description: string;
  url?: string;
  viewStacked?: boolean;
}
function FilePreview({
  description,
  url,
  viewStacked = false,
}: Readonly<IFilePreviewProps>) {
  const classes = useStyles();
  const [showOverlay, setShowOverlay] = useState(false);
  const candidates = url ? [{ url }] : [];
  const { validImages, isLoading } = useValidImages(candidates);
  const isImage = validImages.length > 0;

  const renderContent = () => {
    if (isLoading) {
      return (
        <Box
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
          width="100%"
          height="100%"
        >
          <CircularProgress size={20} />
        </Box>
      );
    }

    if (isImage) {
      return (
        <Box
          display={"grid"}
          alignItems={"center"}
          justifyItems={"center"}
          width="100%"
          height="100%"
        >
          <UploadCell
            value={{
              url,
            }}
            width="100%"
            height="100%"
          />
        </Box>
      );
    }

    return (
      <>
        <Box
          className={classes.overlay}
          style={{
            visibility: showOverlay ? "visible" : "hidden",
            opacity: showOverlay ? "0.5" : "0",
          }}
        >
          <IconButton
            component={"a"}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            centerRipple
            size="large"
          >
            <Avatar className={classes.overlayButton}>
              <CloseFullscreenIcon />
            </Avatar>
          </IconButton>
        </Box>
        <Box className={classes.container}>
          <InsertDriveFileIcon className={classes.icon} />
          <Box className={classes.description}>{description}</Box>
        </Box>
      </>
    );
  };

  return (
    <Box
      onMouseEnter={function () {
        setShowOverlay(true);
      }}
      onMouseLeave={function () {
        setShowOverlay(false);
      }}
      style={{
        ...(viewStacked && {
          height: 90,
          borderRadius: 4,
          width: "100%",
          background: OffWhite,
        }),
        display: "flex",
        justifyItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        position: "relative",
      }}
    >
      {renderContent()}
    </Box>
  );
}

export default FilePreview;
